import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import CompanyDepartmentsTile from './company-departments-tile';

const CompanyDepartments = ({ departments }) => {
  const renderedDepartments = _.map(departments, (department, name) => (
    <CompanyDepartmentsTile {...department} key={`item-${name}`} />
  ));

  return (
    <div>
      <div
        className={classNames([
          'departments__cont',
          classes('margin-horizontal-auto'),
          classes('padding-vertical-0'),
          classes('padding-horizontal-3'),
          classes('padding-horizontal-0--wide'),
          classes('display-flex--wide'),
          classes('flex-direction-row--wide'),
          classes('flex-wrap--wide'),
        ])}
      >
        {renderedDepartments}
      </div>
    </div>
  );
};

CompanyDepartments.displayName = 'Company Departments';

CompanyDepartments.propTypes = {
  departments: PropTypes.arrayOf(PropTypes.shape(CompanyDepartments.propTypes)),
  className: PropTypes.string,
  name: PropTypes.string,
};

export default CompanyDepartments;
